import React, {useContext, useEffect, useState} from "react";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import {Title} from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleMUISelectEvent,
} from "../../../../../utils/UtilFunctions";
import {Button} from "../../../../../stories/Button/Button";
import {useNavigate} from "react-router-dom";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {TableHeaderProps} from "../../../../../utils/types";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import {
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../../utils/Enum.types";
import {StyledDatagrid} from "../../../../../styles/DatagridStyles";
import DeleteModal from "../../../../../customComponents/DeleteModal";

import Add from "./Add";
import {AddModalStyles} from "../../../../../styles/CustomModalStyles";
import Close from "../../../../../images/Close.svg";
import {GetItems} from "./queries/queries";
import {
  AtsStckItemEdge,
  AtsStckItemOrderField,
  GetItemsResult,
  GetItemsVars,
  DeleteItemByIdResult,
  DeleteItemByIdVars,
  filterDataType,
  ItemQueryType,
} from "./queries/types";

import {useLazyQuery, useMutation} from "@apollo/client";
import {
  EMPTY_STRING,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useToken from "../../../../../customHooks/useToken";
import {OrderDirection} from "../../../../../utils/commonQueryTypes";
import {AppContext} from "../../../../../context/context";
import {payloadTypes} from "../../../../../context/reducer";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import {DeleteItem} from "./queries/mutations";
import {itmType} from "../../purchase/material/statesProvider/materialContext";
import LoadingModal from "../../../../pages/LoadingModal";
import ItemGroupSelect from "../../../../../customComponents/ItemGroupSelect";
import ItemCategorySelect from "../../../../../customComponents/ItemCategorySelect";
import UoMSelect from "../../../../../customComponents/UoMSelect";
import ImportItems from "./ImportItems";
import {SpecialKeys} from "../../../../../utils/Enum.keys";
import {useHotKey} from "../../../../../utils/hotKeys";
import Navbar from "../../../../common/layout/Navbar";
import useLabels from "../../../../../customHooks/useLabels";
import {ColumnVisibilityFor} from "../../../../../utils/Enum.Datagrid";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
  onSelect?: (newValue: itmType, uom: AtsStckItemEdge | undefined) => void;
}
const Items = ({pageType, setModalFlag, onSelect}: Props) => {
  const [addModal, setAddModal] = useState(false);
  const navigate = useNavigate();
  const {state, dispatch} = useContext(AppContext);
  const {itemLabel} = useLabels();
  const {Masters_Table} = useAssetTableJson();
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [items, setitems] = useState<AtsStckItemEdge[]>([]);
  const [searchData, setSearchData] = useState("");
  const [filterData, setFilterData] = useState<filterDataType>({
    ItemGroupId: 0,
    ItemCategoryId: 0,
    UoMId: 0,
  });
  const {customer_id, company_id} = useUrlParams();
  const [message, setMessage] = useState(emptyMessage);
  const {user_details} = useLoggedInUserDetails();
  const [importModal, setImportModal] = useState(false);

  const [GetStockItems, {data, loading, fetchMore}] = useLazyQuery<
    GetItemsResult,
    GetItemsVars
  >(GetItems);

  const [DeleteSelectedItem, {loading: deletionLoading}] = useMutation<
    DeleteItemByIdResult,
    DeleteItemByIdVars
  >(DeleteItem, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  //hot key for addition ctrl+a
  useHotKey({
    handleFunc: () => {
      setAddModal(!addModal);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  const dynamicHeaders: TableHeaderProps[] = Masters_Table.Masters.Items.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      cellClassName: header.cellClassName,
      hideable: header.hideable,
    })
  );

  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_ITEM_ID,
                  payload: {
                    itmId: params.row.item_id,
                  },
                });
                setEditModal(!editModal);
              }}
            />
            <img
              src={Delete}
              alt="/"
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_ITEM_ID,
                  payload: {
                    itmId: params.row.item_id,
                  },
                });
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      },
    },
  ];

  const HandleDelete = () => {
    setDeleteModal(!deleteModal);
    DeleteSelectedItem({
      variables: {
        item_id: state.itmId,
        user_details,
      },
      refetchQueries: [
        {
          query: GetItems,
          variables: {
            after: null,
            customerID: customer_id ? customer_id : 0,
            companyID: company_id ? company_id : 0,
            first: ROWS_PER_PAGE,
            orderBy: {
              direction: OrderDirection.ASC,
              field: AtsStckItemOrderField.DESC,
            },

            name: EMPTY_STRING,
            hsnCode: EMPTY_STRING,
            input: {
              query_type: ItemQueryType.All,
              stckCategoryID: 0,
              stckGroupID: 0,
              stckManufacturerID: 0,
              stckUomID: 0,
              stckSubCategoryID: 0,
              ldgrID: 0,
              subsidiaryID: 0,
            },
          },
        },
      ],
    }).then(({data}) => {
      if (data) {
        setMessage({
          flag: true,
          message: `${itemLabel} Deleted Sucessfully`,
          operation: Operation.DELETE,
        });
      }
    });
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItems.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setitems(updatedNewData);
        setRows(
          updatedNewData.map(({node}, index) => ({
            id: index + 1,
            desc: node.desc,
            code: node.code,
            item_group: node.groupDetails.groupName,
            item_category: node.categoryDetails.categoryName,
            unit_of_measurement: node.uomDetails.uom,
            igst: node.igst,
            cgst: node.cgst,
            sgst: node.sgst,
            item_id: node.id,
            item: node,
          }))
        );
      } else {
        setitems(newData);
        setRows(
          newData.map(({node}, index) => ({
            id: index + 1,
            desc: node.desc,
            code: node.code,
            item_group: node.groupDetails.groupName,
            item_category: node.categoryDetails.categoryName,
            unit_of_measurement: node.uomDetails.uom,
            igst: node.igst,
            cgst: node.cgst,
            sgst: node.sgst,
            item_id: node.id,
            item: node,
          }))
        );
      }
      setEndCursor(data.GetItems.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, {fetchMoreResult}) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetItems.edges;
              const pageInfo = fetchMoreResult.GetItems.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetItems.edges.filter(
                ({node: {id}}) =>
                  newEdges.findIndex(({node: {id: newId}}) => newId === id) !==
                  -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetItems: {
                  edges: [...items, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetItems.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    GetStockItems({
      variables: {
        after: null,
        customerID: customer_id ? customer_id : 0,
        companyID: company_id ? company_id : 0,
        first: ROWS_PER_PAGE,
        orderBy: {
          direction: OrderDirection.ASC,
          field: AtsStckItemOrderField.DESC,
        },

        name: searchData,
        hsnCode: EMPTY_STRING,
        input: {
          query_type: ItemQueryType.All,
          stckCategoryID: filterData.ItemCategoryId
            ? filterData.ItemCategoryId
            : 0,
          stckGroupID: filterData.ItemGroupId ? filterData.ItemGroupId : 0,
          stckManufacturerID: 0,
          stckUomID: filterData.UoMId ? filterData.UoMId : 0,
          stckSubCategoryID: 0,
          ldgrID: 0,
          subsidiaryID: 0,
          isComponent: undefined,
        },
      },
    });
  }, [customer_id, GetStockItems, searchData, filterData]);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({
      id: true,
      desc: true,
      code: true,
      company: false,
      item_group: true,
      item_category: true,
      unit_of_measurement: true,
      igst: false,
      cgst: false,
      sgst: false,
      actions: true,
    });

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.STOCK_ASSET);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.STOCK_ASSET,
      JSON.stringify(newModel)
    );
  };
  return (
    <>
      {pageType === PageFor.GENERAL && company_id ? (
        <Navbar NavType={LicenseTypes.COMPANY} />
      ) : (
        <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      )}
      <div className="items__title">
        <Title>Stock {itemLabel}</Title>
        {pageType === PageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        )}
      </div>
      <div className={`items${pageType === PageFor.GENERAL ? "" : "--modal"}`}>
        <div className="items__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
          <div className="col-2">
            <ItemGroupSelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    ItemGroupId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    ItemGroupId: 0,
                  });
                }
              }}
              value={filterData.ItemGroupId}
              onKeyDown={handleMUISelectEvent}
              label={`${itemLabel} Group`}
            />
          </div>
          <div className="col-2">
            <ItemCategorySelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    ItemCategoryId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    ItemCategoryId: 0,
                  });
                }
              }}
              value={filterData.ItemCategoryId}
              label={`${itemLabel} Category`}
              onKeyDown={handleMUISelectEvent}
            />
          </div>
          <div className="col-2">
            <UoMSelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    UoMId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    UoMId: 0,
                  });
                }
              }}
              value={filterData.UoMId}
              label="Unit of Measurement"
              onKeyDown={handleMUISelectEvent}
            />
          </div>
          <div className="col flex-end">
            <Button
              mode="addnew"
              onClick={() => setAddModal(!addModal)}
              autoFocus
            />
          </div>
        </div>
        <div className="items__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={(params) => {
              if (params.field === "item_desc") {
                setViewModal(!viewModal);
                if (onSelect) {
                  onSelect(
                    {
                      label: params.row.desc,
                      value: params.row.item_id,
                      code: params.row.item.code,
                    } as itmType,
                    {
                      node: params.row.item,
                      cursor: EMPTY_STRING,
                    }
                  );
                }
              }
            }}
            disableRowSelectionOnClick
            hideFooter
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
          />
        </div>
        <div className="row g-0">
          <div className="col">
            {pageType === PageFor.GENERAL ? (
              <Button
                mode="excel"
                type="button"
                onClick={() => setImportModal(true)}
              >
                Import Stock {itemLabel}
              </Button>
            ) : null}
            {pageType === PageFor.GENERAL ? (
              <Button mode="back" onClick={() => navigate(-1)} />
            ) : (
              <Button mode="cancel" onClick={() => setModalFlag(false)} />
            )}
          </div>
          <div className="col-2 flex-end">
            <div className="overall-total-count">
              Total {itemLabel} : <b>{data ? data.GetItems.totalCount : 0}</b>
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        id={state.itmId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />

      <CustomModal
        isOpen={addModal}
        onRequestClose={() => setAddModal(!addModal)}
        contentComponent={
          <Add setModalFlag={setAddModal} operation={Operation.CREATE} />
        }
        style={AddModalStyles}
      />
      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        contentComponent={
          <Add setModalFlag={setEditModal} operation={Operation.UPDATE} />
        }
        style={AddModalStyles}
      />
      <CustomModal
        isOpen={viewModal}
        onRequestClose={() => setViewModal(!viewModal)}
        contentComponent={
          <Add setModalFlag={setViewModal} operation={Operation.VIEW} />
        }
        style={AddModalStyles}
      />
      <LoadingModal flag={(!searchData && loading) || deletionLoading} />
      <CustomModal
        isOpen={importModal}
        onRequestClose={() => setImportModal(!importModal)}
        contentComponent={<ImportItems setModalFlag={setImportModal} />}
        style={AddModalStyles}
      />
    </>
  );
};

export default Items;
